import React from 'react'
import classes from "./ProjectHero.module.css"

const ProjectHero = () => {
  return (
    <section className={classes.project_hero}>
      <h2 className={classes.hero_header}>My Projects</h2>
    </section>
  );
}

export default ProjectHero;